import { get } from "lodash";
import * as R from "ramda";

export const isFetching = state => state.organization.organization.fetching;
export const organization = state =>
  state.organization.organization.organization;
export const orgEvents = state => get(organization(state), "events", []);
export const orgDetails = state =>
  state.organization.organization.organization || {};
export const getIsLightOrg = state => get(organization(state), "is_light");

export const subscription = state =>
  get(organization(state), "subscription") || {};
export const orgId = state => get(organization(state), "id");

export const isFeatureEnabled = state => feature => {
  return R.pathOr(
    [],
    ["organization", "organization", "organization", "enabled_features"]
  )(state).includes(feature);
};
